// Distance à vol d'oiseau (formule de haversine), en km.
export function haversineKm(a, b) {
  if (!a || !b) return null;
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

// Estimation de la distance routière à partir de la distance à vol d'oiseau
// (facteur de détour moyen ~1.3). Arrondi au km.
export function roadDistanceKm(a, b) {
  const d = haversineKm(a, b);
  if (d == null) return null;
  return Math.max(1, Math.round(d * 1.3));
}

// Base de l'entreprise : Villepinte (93). Zone locale = cercle de 10 km de
// diamètre (rayon 5 km) autour de ce point. Si la prise en charge ET le dépôt
// s'y trouvent, la course est facturée au tarif de base (voir backend).
export const VILLEPINTE = { lat: 48.9556, lng: 2.5406 };
export const LOCAL_ZONE_RADIUS_KM = 5;

// Un point est-il dans la zone locale de Villepinte ?
export function isInLocalZone(point) {
  if (!point || point.lat == null || point.lng == null) return false;
  const d = haversineKm(VILLEPINTE, point);
  return d != null && d <= LOCAL_ZONE_RADIUS_KM;
}

// La course entière (départ + arrivée) est-elle dans la zone locale ?
export function isLocalTrip(pickup, dropoff) {
  return isInLocalZone(pickup) && isInLocalZone(dropoff);
}
